/**
 * 模版市场模态框组件
 * @author chenqunfeng
 * @since 17/10/31
 */

import './store-tpl-modal.less';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'containers/modal';
import {
  RP_H5,
  RP_VIDEO,
  RP_GAME,
  PREVIEW_MODAL,
  PREVIEW_VIDEO_MODAL,
  PREVIEW_GAME_MODAL,
  SHOW_BY_URL,
} from 'constants/variable.json5';

class StoreTplModal extends Component {
  static propTypes = {
    showModal: PropTypes.func,
  };

  showPreviewByUrl() {
    // const hashArray = location.hash.split('#');
    const hashArray = decodeURIComponent(location.href).split('#');
    const id = hashArray[1];
    const type = hashArray[2] || RP_H5;
    const category = hashArray[3] || '';

    if (id) {
      this.props.showModal({
        modalType:
          type === RP_VIDEO
            ? PREVIEW_VIDEO_MODAL
            : type === RP_GAME
            ? PREVIEW_GAME_MODAL
            : PREVIEW_MODAL,
        modalProps: {
          presetData: { id, type, category, showByUrl: SHOW_BY_URL },
        },
      });
    }
  }

  componentDidMount() {
    this.showPreviewByUrl();
  }

  render() {
    return (
      <div className="store-tpl-modal">
        <Modal />
      </div>
    );
  }
}

export default StoreTplModal;
